/*  iceberg-ui  */
import { IconWithVariant } from '@auviknetworks/iceberg-ui';

/*  Shared  */
import { FontSizes } from 'application/Shared/Constants';

/*  React  */
import React from 'react';

export const Google = ({ size = FontSizes[1], style, variant = 'primary' }) => (
    <IconWithVariant
        data-testid="googleIcon"
        variant={variant}
        src="Google"
        size={size}
        wrapperProps={{ ...style }}
    />
);
